module.exports = __webpack_public_path__ + "media/images/official/voice_ichihara-2f6ee0d3f5c7c54047a093ef16ae6e83.png";